export default __webpack_public_path__ + "static/media/MagicalStringsGroup_opt.68b53d3b.jpg";